export default __webpack_public_path__ + "static/media/icon_ui_dropdown.ee6213be.png";